import { v4 } from 'uuid';
import type {
  ChatSeedNavigateFn,
  ChatSeedNavigateInput,
  ChatSeedNavigateResult,
  ChatSeedStrategy,
} from './types';

export function navigateChatSeed(
  strategy: Pick<ChatSeedStrategy, 'buildUrlSearchParams'>,
  navigateFn: ChatSeedNavigateFn,
  orgSlug: string,
  input: ChatSeedNavigateInput
): ChatSeedNavigateResult {
  const chatId = input.chatId ?? v4();
  const search = strategy.buildUrlSearchParams(input).toString();

  navigateFn(`/${orgSlug}/chats/${chatId}?${search}`, {
    state: {
      newChat: true,
      ...(input.folderId !== undefined && { folderId: input.folderId }),
    },
    ...(input.replace === true && { replace: true }),
  });

  return { chatId, artifactId: input.artifactId };
}
